import React from 'react';
import PropTypes from 'prop-types';
import { AsYouType, formatIncompletePhoneNumber } from 'libphonenumber-js';

import { Input } from 'modules/common';

function PhoneNumberText({ onChange, name, value, ...props }) {
  const onPhoneChange = event => {
    // issue: https://github.com/catamphetamine/libphonenumber-js/issues/225
    const numberValue = event.target.value;
    let newValue = numberValue ? new AsYouType('US').input(numberValue) : '';
    const newValueFormatted = formatIncompletePhoneNumber(value, 'US');

    if (newValue === newValueFormatted && newValueFormatted.indexOf(event.target.value) === 0) {
      newValue = newValue.slice(0, -1);
    }

    onChange({ target: { name, value: newValue } });
  };

  return <Input type="tel" onChange={onPhoneChange} value={value} {...props} />;
}

PhoneNumberText.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
};

export default PhoneNumberText;
